(function ( $ ) {

	// Uses http://kenwheeler.github.io/slick/
	$.fn.slickcarousel = function ( options ) {
		var elem = $( this ),
			parent = elem.parent(),
			settings = {
				centerMode    : true,
				dots: true,
				slidesToShow  : 2,
				variableWidth : true,
				prevArrow: '<span class="slick-prev"><i class="fa fa-arrow-left"></i></span>',
				nextArrow: '<span class="slick-next"><i class="fa fa-arrow-right"></i></span>',
				appendArrows: elem.siblings('.slider__controls'),
				appendDots: elem.siblings('.slider__controls')

			};

		var init = function () {
			elem.slick( settings );
		};

		init();
		return this;
	};

}( jQuery ));
